import { type ReactNode } from 'react';

import { useListingLayoutIsNarrowSelector } from '@/packages/redux-state/store/slices/listingLayout';

import { CardFeatureLabelsContainer } from '../../CardFeatureLabels';
import { GallerySliderAddonsLayout } from '../components/GallerySliderAddonsLayout';

import { GalleryActionButtons } from './GalleryActionButtons';
import { GalleryLabelsContainer } from './GalleryLabelsContainer';

export function SliderAddonsContainer(): ReactNode {
  const isNarrow = useListingLayoutIsNarrowSelector();

  if (isNarrow) {
    return <GallerySliderAddonsLayout topLeft={<GalleryLabelsContainer />} topRight={<GalleryActionButtons />} />;
  }

  return <GallerySliderAddonsLayout topLeft={<GalleryLabelsContainer />} topRight={<CardFeatureLabelsContainer />} />;
}
